export default __webpack_public_path__ + "static/media/wroclaw.55833ab3.jpg";